import * as moment from 'moment/moment';
import { Moment } from 'moment';

export function convertDateBasedOnUserTimeZone(date: Date, userTimeZone, resetSecMS: boolean = false): Moment {
    if (resetSecMS) {
        date.setSeconds(0, 0);
    }
    return moment(date).clone().utcOffset(userTimeZone, true);
}
